import Keycloak from 'keycloak-js';

import {CONFIGS} from "./constants";

export const keycloak = Keycloak(CONFIGS.keycloack);
